import React, { useEffect, useState } from 'react';
import { CheckCircle, XCircle, XOctagon, Home, ArrowLeft } from 'lucide-react';
import './PaymentStatus.css';

const PaymentStatus = () => {
  const [status, setStatus] = useState('');
  const [queryParams, setQueryParams] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [callbackSent, setCallbackSent] = useState(false);

  useEffect(() => {
    // URL-დან სტატუსის და პარამეტრების წაკითხვა
    const path = window.location.pathname.toLowerCase();
    const searchParams = new URLSearchParams(window.location.search);
    
    // GET პარამეტრების შენახვა
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    setQueryParams(params);
    
    // სტატუსის დადგენა URL-ის მიხედვით
    if (path.includes('successurl') || path.includes('success')) {
      setStatus('success');
    } else if (path.includes('errorurl') || path.includes('error')) {
      setStatus('error');
    } else if (path.includes('cancelurl') || path.includes('cancel')) {
      setStatus('cancel');
    } else if (path.includes('callback')) {
      setStatus('processing');
    }
    
    // Loading ანიმაციის გამორთვა
    setTimeout(() => setIsLoading(false), 500);
  }, []);

  // Callback POST request გაგზავნა
  useEffect(() => {
    const sendCallback = async () => {
      // გაგზავნა მხოლოდ წარმატების შემთხვევაში და ერთხელ
      if (status === 'success' && Object.keys(queryParams).length > 0 && !callbackSent) {
        try {
          const response = await fetch('https://api.geoglobalgate.com/api/pay/callback', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(queryParams)
          });

          const result = await response.json();
          console.log('Callback Response:', result);
          setCallbackSent(true);
        } catch (error) {
          console.error('Callback Error:', error);
          // არ ვაჩვენებთ error-ს მომხმარებელს, რადგან გადახდა მაინც წარმატებულია
        }
      }
    };

    sendCallback();
  }, [status, queryParams, callbackSent]);

  // კონფიგურაცია თითოეული სტატუსისთვის
  const statusConfig = {
    success: {
      icon: CheckCircle,
      title: 'გადახდა წარმატებით დასრულდა!',
      subtitle: 'თქვენი ტრანზაქცია წარმატებით დამუშავდა',
      iconClass: 'icon-success',
      containerClass: 'status-container success-container',
      headerClass: 'status-header success-header',
    },
    error: {
      icon: XCircle,
      title: 'გადახდა ვერ შესრულდა',
      subtitle: 'ტრანზაქციის დამუშავებისას მოხდა შეცდომა',
      iconClass: 'icon-error',
      containerClass: 'status-container error-container',
      headerClass: 'status-header error-header',
    },
    cancel: {
      icon: XOctagon,
      title: 'გადახდა გაუქმდა',
      subtitle: 'თქვენ გააუქმეთ ტრანზაქცია',
      iconClass: 'icon-cancel',
      containerClass: 'status-container cancel-container',
      headerClass: 'status-header cancel-header',
    },
    processing: {
      icon: null,
      title: 'მიმდინარეობს ტრანზაქციის დამუშავება',
      subtitle: 'გთხოვთ მოიცადოთ...',
      iconClass: 'icon-processing',
      containerClass: 'status-container processing-container',
      headerClass: 'status-header processing-header',
      isProcessing: true
    }
  };

  const config = statusConfig[status] || {};
  const Icon = config.icon;

  // Loading state
  if (isLoading || !status) {
    return (
      <div className="payment-status-wrapper loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="payment-status-wrapper">
      <div className={config.containerClass}>
        {/* Header with gradient */}
        <div className={config.headerClass}>
          <div className="header-decoration-1"></div>
          <div className="header-decoration-2"></div>
          
          <div className="icon-wrapper">
            <div className={`icon-circle ${config.iconClass}`}>
              {config.isProcessing ? (
                <div className="processing-spinner"></div>
              ) : (
                Icon && <Icon size={48} />
              )}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="status-content">
          <h2 className="status-title">
            {config.title}
          </h2>
          <p className="status-subtitle">
            {config.subtitle}
          </p>

          {/* Action Buttons */}
          <div className="action-buttons">
            {status === 'error' && (
              <button 
                onClick={() => window.history.back()}
                className="btn btn-primary btn-error-primary"
              >
                <ArrowLeft size={20} />
                <span>თავიდან ცდა</span>
              </button>
            )}
            
            {status === 'cancel' && (
              <button 
                onClick={() => window.history.back()}
                className="btn btn-primary btn-cancel-primary"
              >
                <ArrowLeft size={20} />
                <span>უკან დაბრუნება</span>
              </button>
            )}
            
            <button 
              onClick={() => window.location.href = '/'}
              className="btn btn-secondary"
            >
              <Home size={20} />
              <span>მთავარ გვერდზე გადასვლა</span>
            </button>
          </div>

          {/* Additional Info - მხოლოდ ძირითადი ინფო */}
          {status === 'success' && (
            <div className="additional-info">
              <p className="info-text">
                ✓ გადახდა დადასტურებულია
              </p>
              {/* <p className="info-text">
                თანხა: {queryParams.amount} {queryParams.currency}
              </p> */}
              <p className="info-text">
                თარიღი: {new Date().toLocaleDateString('ka-GE')}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentStatus;